export default __webpack_public_path__ + "static/media/2022_image.cb606873.png";